"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appOperationResultSchema = exports.appAuditLogResponseSchema = exports.appAuditLogEntrySchema = exports.appWebhookDeliveryListResponseSchema = exports.appWebhookDeliverySchema = exports.appWebhookDeliveryAttemptSchema = exports.createAppSessionResponseSchema = exports.appSessionResourceContextSchema = exports.createAppSessionRequestSchema = exports.appSessionThemeSchema = exports.appRuntimeExtensionsResponseSchema = exports.resolvedAppExtensionSchema = exports.appRuntimeNavigationResponseSchema = exports.appRuntimeNavigationItemSchema = exports.rotateAppSecretResponseSchema = exports.activateAppAddonRequestSchema = exports.updateAppConfigurationRequestSchema = exports.installAppRequestSchema = exports.appCatalogDetailSchema = exports.appCatalogListResponseSchema = exports.appCatalogItemSchema = exports.appEntitlementSummarySchema = exports.appInstallationSummarySchema = exports.appWebhookAttemptOutcomeSchema = exports.appWebhookDeliveryStatusSchema = exports.appHealthStatusSchema = exports.appConnectionStateSchema = exports.appSetupStateSchema = exports.appInstallationLifecycleStateSchema = exports.appEntitlementStatusSchema = exports.appCatalogEntryKindSchema = exports.appCatalogLifecycleStatusSchema = exports.appCatalogDiscoverabilitySchema = exports.appManagementPermissionSchema = exports.APP_MANAGEMENT_PERMISSIONS = void 0;
const app_sdk_1 = require("@crewfsm/app-sdk");
const zod_1 = require("zod");
exports.APP_MANAGEMENT_PERMISSIONS = [
    "apps:read",
    "apps:manage",
    "apps:configure",
    "apps:use",
];
exports.appManagementPermissionSchema = zod_1.z.enum(exports.APP_MANAGEMENT_PERMISSIONS);
exports.appCatalogDiscoverabilitySchema = zod_1.z.enum([
    "DISCOVERABLE",
    "HIDDEN",
    "COMING_SOON",
]);
exports.appCatalogLifecycleStatusSchema = zod_1.z.enum([
    "DRAFT",
    "PUBLISHED",
    "DEPRECATED",
    "DISABLED",
]);
exports.appCatalogEntryKindSchema = zod_1.z.enum([
    "APP",
    "BUILT_IN_INTEGRATION",
]);
exports.appEntitlementStatusSchema = zod_1.z.enum([
    "ENTITLED",
    "PLAN_REQUIRED",
    "NOT_ENTITLED",
]);
exports.appInstallationLifecycleStateSchema = zod_1.z.enum([
    "AVAILABLE",
    "CONFIGURING",
    "ACTIVE",
    "NEEDS_ATTENTION",
    "DISABLED",
    "REVOKED",
]);
exports.appSetupStateSchema = zod_1.z.enum([
    "NOT_STARTED",
    "IN_PROGRESS",
    "COMPLETE",
]);
exports.appConnectionStateSchema = zod_1.z.enum([
    "NOT_REQUIRED",
    "DISCONNECTED",
    "CONNECTING",
    "CONNECTED",
    "ERROR",
]);
exports.appHealthStatusSchema = zod_1.z.enum([
    "HEALTHY",
    "SETUP_REQUIRED",
    "AUTH_EXPIRED",
    "DELIVERY_FAILURES",
    "VERSION_INCOMPATIBLE",
    "DISABLED",
    "UNKNOWN",
]);
exports.appWebhookDeliveryStatusSchema = zod_1.z.enum([
    "PENDING",
    "PROCESSING",
    "SUCCEEDED",
    "RETRY_SCHEDULED",
    "DEAD_LETTER",
    "CANCELED",
]);
exports.appWebhookAttemptOutcomeSchema = zod_1.z.enum([
    "SUCCEEDED",
    "RETRYABLE_FAILURE",
    "PERMANENT_FAILURE",
    "CANCELED",
]);
const appIconSchema = app_sdk_1.appManifestV2Schema.shape.icon;
const appIdSchema = zod_1.z.string().min(3).max(80);
const jsonPrimitiveSchema = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.boolean(),
    zod_1.z.null(),
]);
const jsonValueSchema = zod_1.z.lazy(() => zod_1.z.union([
    jsonPrimitiveSchema,
    zod_1.z.array(jsonValueSchema),
    zod_1.z.record(zod_1.z.string(), jsonValueSchema),
]));
exports.appInstallationSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    appId: appIdSchema,
    appVersion: zod_1.z.string(),
    lifecycleState: exports.appInstallationLifecycleStateSchema,
    setupState: exports.appSetupStateSchema,
    connectionState: exports.appConnectionStateSchema,
    healthStatus: exports.appHealthStatusSchema,
    configuration: zod_1.z.record(zod_1.z.string(), jsonValueSchema),
    grantedPermissions: zod_1.z.array(app_sdk_1.appPermissionSchema),
    subscribedEvents: zod_1.z.array(app_sdk_1.builtInIntegrationEventTypeSchema),
    installedAt: zod_1.z.string().datetime(),
    activatedAt: zod_1.z.string().datetime().nullable(),
    disabledAt: zod_1.z.string().datetime().nullable(),
    revokedAt: zod_1.z.string().datetime().nullable(),
});
exports.appEntitlementSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    appId: appIdSchema,
    source: zod_1.z.enum(["INCLUDED", "PLAN", "ADD_ON", "TRIAL", "MANUAL"]),
    planOrAddonReference: zod_1.z.string().nullable(),
    active: zod_1.z.boolean(),
    activatedAt: zod_1.z.string().datetime(),
    deactivatedAt: zod_1.z.string().datetime().nullable(),
});
exports.appCatalogItemSchema = zod_1.z.object({
    id: appIdSchema,
    slug: zod_1.z.string().min(2).max(80),
    name: zod_1.z.string().min(1).max(120),
    description: zod_1.z.string().min(1).max(500),
    category: zod_1.z.string().min(1).max(80),
    icon: appIconSchema,
    publisher: zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        kind: app_sdk_1.appPublisherKindSchema,
    }),
    deliveryModel: app_sdk_1.appDeliveryModelSchema,
    uiRuntime: app_sdk_1.appUiRuntimeSchema,
    commercialModel: app_sdk_1.appCommercialModelSchema,
    supportedPlatforms: zod_1.z.array(app_sdk_1.appSupportedPlatformSchema),
    currentVersion: zod_1.z.string(),
    discoverability: exports.appCatalogDiscoverabilitySchema,
    catalogStatus: exports.appCatalogLifecycleStatusSchema,
    entitlementStatus: exports.appEntitlementStatusSchema,
    planRequirements: zod_1.z.array(zod_1.z.string()),
    entryKind: exports.appCatalogEntryKindSchema.optional(),
    managementHref: zod_1.z.string().startsWith("/").max(240).nullable().optional(),
    installation: exports.appInstallationSummarySchema.nullable(),
    entitlement: exports.appEntitlementSummarySchema.nullable(),
});
exports.appCatalogListResponseSchema = zod_1.z.object({
    apps: zod_1.z.array(exports.appCatalogItemSchema),
    categories: zod_1.z.array(zod_1.z.string()),
});
exports.appCatalogDetailSchema = exports.appCatalogItemSchema.extend({
    catalogManifest: app_sdk_1.appManifestV2Schema.optional(),
    manifest: app_sdk_1.appManifestV2Schema,
});
exports.installAppRequestSchema = zod_1.z.object({
    permissions: zod_1.z.array(app_sdk_1.appPermissionSchema).optional(),
    subscriptions: zod_1.z.array(app_sdk_1.builtInIntegrationEventTypeSchema).optional(),
});
exports.updateAppConfigurationRequestSchema = zod_1.z.object({
    configuration: zod_1.z.record(zod_1.z.string(), jsonValueSchema),
    subscriptions: zod_1.z.array(app_sdk_1.builtInIntegrationEventTypeSchema).optional(),
});
exports.activateAppAddonRequestSchema = zod_1.z.object({
    source: zod_1.z
        .enum(["INCLUDED", "PLAN", "ADD_ON", "TRIAL", "MANUAL"])
        .default("INCLUDED"),
    planOrAddonReference: zod_1.z.string().trim().min(1).max(160).optional(),
});
exports.rotateAppSecretResponseSchema = zod_1.z.object({
    secret: zod_1.z.string().min(32),
    fingerprint: zod_1.z.string().length(64),
    createdAt: zod_1.z.string().datetime(),
});
exports.appRuntimeNavigationItemSchema = zod_1.z.object({
    appId: appIdSchema,
    appSlug: zod_1.z.string(),
    appName: zod_1.z.string(),
    appIcon: appIconSchema,
    installationId: zod_1.z.string().uuid().nullable(),
    entitlementId: zod_1.z.string().uuid().nullable(),
    homePath: zod_1.z.string(),
    renderer: zod_1.z.enum(["NATIVE", "IFRAME"]),
    items: zod_1.z.array(app_sdk_1.appNavigationItemSchema),
    healthStatus: exports.appHealthStatusSchema,
});
exports.appRuntimeNavigationResponseSchema = zod_1.z.object({
    apps: zod_1.z.array(exports.appRuntimeNavigationItemSchema),
});
exports.resolvedAppExtensionSchema = zod_1.z.object({
    appId: appIdSchema,
    appSlug: zod_1.z.string(),
    appName: zod_1.z.string(),
    appIcon: appIconSchema,
    installationId: zod_1.z.string().uuid().nullable(),
    entitlementId: zod_1.z.string().uuid().nullable(),
    accessState: zod_1.z.enum(["ACTIVE", "LOCKED"]),
    extension: app_sdk_1.appUiExtensionSchema,
    effectivePermissions: zod_1.z.array(app_sdk_1.appPermissionSchema),
});
exports.appRuntimeExtensionsResponseSchema = zod_1.z.object({
    extensions: zod_1.z.array(exports.resolvedAppExtensionSchema),
});
exports.appSessionThemeSchema = zod_1.z.enum(["LIGHT", "DARK", "SYSTEM"]);
exports.createAppSessionRequestSchema = zod_1.z.object({
    installationId: zod_1.z.string().uuid(),
    target: app_sdk_1.appUiTargetSchema,
    resourceType: app_sdk_1.appResourceTypeSchema.optional(),
    resourceId: zod_1.z.string().uuid().optional(),
    currentRoute: zod_1.z
        .string()
        .startsWith("/apps/")
        .max(260)
        .refine((value) => !value.includes("?") &&
        !value.includes("#") &&
        !value.includes("\\") &&
        !value.split("/").includes(".."), "A safe app route is required."),
    locale: zod_1.z.string().min(2).max(20).default("en-US"),
    timezone: zod_1.z.string().min(1).max(64),
    theme: exports.appSessionThemeSchema.default("SYSTEM"),
});
exports.appSessionResourceContextSchema = zod_1.z.object({
    locationId: zod_1.z.string().uuid().optional(),
    target: app_sdk_1.appUiTargetSchema,
    resourceType: app_sdk_1.appResourceTypeSchema.optional(),
    resourceId: zod_1.z.string().uuid().optional(),
    currentRoute: zod_1.z.string(),
    locale: zod_1.z.string(),
    timezone: zod_1.z.string(),
    theme: exports.appSessionThemeSchema,
    effectivePermissions: zod_1.z.array(app_sdk_1.appPermissionSchema),
});
exports.createAppSessionResponseSchema = zod_1.z.object({
    token: zod_1.z.string().min(32),
    expiresAt: zod_1.z.string().datetime(),
    context: exports.appSessionResourceContextSchema,
});
exports.appWebhookDeliveryAttemptSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    attemptNumber: zod_1.z.number().int().positive(),
    outcome: exports.appWebhookAttemptOutcomeSchema,
    responseStatus: zod_1.z.number().int().nullable(),
    responseMetadata: zod_1.z.record(zod_1.z.string(), jsonValueSchema),
    errorCode: zod_1.z.string().nullable(),
    errorMessage: zod_1.z.string().nullable(),
    durationMs: zod_1.z.number().int().nonnegative(),
    attemptedAt: zod_1.z.string().datetime(),
});
exports.appWebhookDeliverySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    eventId: zod_1.z.string().uuid(),
    eventType: zod_1.z.string(),
    eventVersion: zod_1.z.number().int().positive(),
    resourceType: app_sdk_1.appResourceTypeSchema.nullable(),
    resourceId: zod_1.z.string().uuid().nullable(),
    status: exports.appWebhookDeliveryStatusSchema,
    attemptCount: zod_1.z.number().int().nonnegative(),
    maximumAttempts: zod_1.z.number().int().positive(),
    nextAttemptAt: zod_1.z.string().datetime(),
    occurredAt: zod_1.z.string().datetime(),
    completedAt: zod_1.z.string().datetime().nullable(),
    deadLetteredAt: zod_1.z.string().datetime().nullable(),
    resolvedAt: zod_1.z.string().datetime().nullable().default(null),
    lastResponseStatus: zod_1.z.number().int().nullable(),
    lastErrorCode: zod_1.z.string().nullable(),
    attempts: zod_1.z.array(exports.appWebhookDeliveryAttemptSchema),
});
exports.appWebhookDeliveryListResponseSchema = zod_1.z.object({
    deliveries: zod_1.z.array(exports.appWebhookDeliverySchema),
});
exports.appAuditLogEntrySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    operation: zod_1.z.string(),
    actorSubject: zod_1.z.string(),
    result: zod_1.z.string(),
    metadata: zod_1.z.record(zod_1.z.string(), jsonValueSchema),
    createdAt: zod_1.z.string().datetime(),
});
exports.appAuditLogResponseSchema = zod_1.z.object({
    entries: zod_1.z.array(exports.appAuditLogEntrySchema),
});
exports.appOperationResultSchema = zod_1.z.object({
    installation: exports.appInstallationSummarySchema.optional(),
    entitlement: exports.appEntitlementSummarySchema.optional(),
});
//# sourceMappingURL=app-platform.js.map